export default __webpack_public_path__ + "static/hipaa-2026-ddb89d709731f99025431987993d7b25.pdf";